module.exports = __webpack_public_path__ + "img/18.18738d0e.png";